import { Instance, types } from 'mobx-state-tree';

const TimeZone = types.model('TimeZone', {
	id: types.identifierNumber,
	name: types.optional(types.string, ''),
});

export default TimeZone;

export interface ITimeZoneModel extends Instance<typeof TimeZone> {}
